module.exports = __webpack_public_path__ + "94cc4769cd46c9b22fe75067e16101a8.pdf";